import { render } from "./InternationalShipping.vue?vue&type=template&id=0528681f&scoped=true"
import script from "./InternationalShipping.vue?vue&type=script&lang=js"
export * from "./InternationalShipping.vue?vue&type=script&lang=js"

import "./InternationalShipping.vue?vue&type=style&index=0&id=0528681f&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0528681f"]])

export default __exports__